import { createReducer, on } from '@ngrx/store';
import { PaginationResponse } from '@shared/models/common.model';
import * as WalletActions from './wallet.actions';
import { Wallet, WalletWhitelistAddressItem } from '../../models/wallet.model';

export const SHARED_WALLET_FEATURE_KEY = 'sharedWallet';

export interface SharedWalletState {
  walletWhitelistAddresses: WalletWhitelistAddressItem[];
  walletWhitelistAddressesLoading: boolean;
  walletWhitelistAddressesError: string | null;
  walletDetails: Wallet | null;
  walletDetailsLoading: boolean;
  walletDetailsError: string | null;

  walletWhitelistAddressesPagination: PaginationResponse | null;
}

export const initialState: SharedWalletState = {
  walletWhitelistAddresses: [],
  walletWhitelistAddressesLoading: false,
  walletWhitelistAddressesError: null,
  walletDetails: null,
  walletDetailsLoading: false,
  walletDetailsError: null,
  walletWhitelistAddressesPagination: null,
};

export const sharedWalletReducer = createReducer(
  initialState,

  on(WalletActions.loadWalletWhitelistAddresses, state => ({
    ...state,
    walletWhitelistAddressesLoading: true,
    walletWhitelistAddressesError: null,
  })),

  on(
    WalletActions.loadWalletWhitelistAddressesSuccess,
    (state, { response }) => ({
      ...state,
      walletWhitelistAddresses: response.data.walletWhitelistAddresses,
      walletWhitelistAddressesPagination: response.pagination,
      walletWhitelistAddressesLoading: false,
      walletWhitelistAddressesError: null,
    })
  ),

  on(WalletActions.loadWalletWhitelistAddressesFailure, (state, { error }) => ({
    ...state,
    walletWhitelistAddressesLoading: false,
    walletWhitelistAddressesError: error,
  })),

  on(WalletActions.loadWalletDetails, state => ({
    ...state,
    walletDetailsLoading: true,
    walletDetailsError: null,
    walletDetails: null,
  })),

  on(WalletActions.loadWalletDetailsSuccess, (state, { data }) => ({
    ...state,
    walletDetailsLoading: false,
    walletDetailsError: null,
    walletDetails: data,
  })),

  on(WalletActions.loadWalletDetailsFailure, (state, { error }) => ({
    ...state,
    walletDetailsLoading: false,
    walletDetailsError: error,
    walletDetails: null,
  }))
);
